import { Box, Grid } from "@mui/material";
import { useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { fetchWeatherForecastDataRequest } from "./store/actions/weatherForecast.actions";
import WeatherWidget from "./WeatherWidget.component";

const WeatherForecastComponent = ({ position }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const weatherForecast = useSelector((state) => state.weatherForecast?.data);

  const weatherData = useMemo(
    () => ({
      weather: weatherForecast?.current?.condition?.text ?? "-",
      iconCurrent: weatherForecast?.current?.condition?.icon,
      iconForecast:
        weatherForecast?.forecast?.forecastday[1]?.day?.condition?.icon,
      maxTemp: weatherForecast?.forecast?.forecastday[0]?.day?.maxtemp_c ?? "-",
      minTemp: weatherForecast?.forecast?.forecastday[0]?.day?.mintemp_c ?? "-",
      humidity: weatherForecast?.current?.humidity ?? "-",
      rain: weatherForecast?.current?.precip_mm ?? "-",
      wind: weatherForecast?.current?.wind_kph ?? "-",
      windDirection: weatherForecast?.current?.wind_dir ?? "-",
      forecastDay: weatherForecast?.forecast?.forecastday[1]?.date ?? "-",
      forecastMinTemp:
        weatherForecast?.forecast?.forecastday[1]?.day?.mintemp_c ?? "-",
      forecastMaxTemp:
        weatherForecast?.forecast?.forecastday[1]?.day?.maxtemp_c ?? "-",
      forecastAvgHumidity:
        weatherForecast?.forecast?.forecastday[1]?.day?.avghumidity ?? "-",
      forecastTotalPrecip_mm:
        weatherForecast?.forecast?.forecastday[1]?.day?.totalprecip_mm ?? "-",
      forecastMaxWind_kph:
        weatherForecast?.forecast?.forecastday[1]?.day?.maxwind_kph ?? "-",
      temp_c: weatherForecast?.current?.temp_c ?? "-",
      location: weatherForecast?.location?.name ?? "-",
    }),
    [weatherForecast]
  );

  useEffect(() => {
    dispatch(fetchWeatherForecastDataRequest(position));
  }, [position, dispatch]);

  return (
    <Box height="auto" width="auto">
      <Grid container spacing={2}>
        <Grid item xs={12} md={12}>
          <WeatherWidget
            iconCurrent={weatherData.iconCurrent}
            weather={weatherData.weather}
            day={t("weather-forecast.today")}
            temperature={weatherData.temp_c}
            minTemp={weatherData.minTemp}
            maxTemp={weatherData.maxTemp}
            humidity={weatherData.humidity}
            rain={weatherData.rain}
            wind={weatherData.wind}
            windDirection={weatherData.windDirection}
            location={weatherData.location}
          />
        </Grid>
        <Grid item xs={12} md={12}>
          <WeatherWidget
            iconCurrent={weatherData.iconForecast}
            weather={weatherData.weather}
            day={t("weather-forecast.tomorrow")}
            minTemp={weatherData.forecastMinTemp}
            maxTemp={weatherData.forecastMaxTemp}
            humidity={weatherData.forecastAvgHumidity}
            rain={weatherData.forecastTotalPrecip_mm}
            wind={weatherData.forecastMaxWind_kph}
            windDirection={weatherData.windDirection}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default WeatherForecastComponent;
